import utils from '../utils/utils'
import globalVar from '../utils/globalVar'

class Horaire {
  constructor() {
    const tablet = window.matchMedia("(max-width: 1040px)");
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.horaires = document.querySelectorAll('.axios_horaire');
      if(tablet && document.querySelector('.axios_mobile')) {
        cache.horaireM = document.querySelector('.axios_mobile');
      }
    };

    let registerEvents = () => {
      for (var i = 0; i < cache.horaires.length; i++) {
        getHours(cache.horaires[i].dataset.idplaces, cache.horaires[i]);
      }
      if(tablet && document.querySelector('.axios_mobile')) {
        getHoursM(cache.horaireM.dataset.idplaces, cache.horaireM);
      }
    };

    let getHours = (id, parent) => {
      const service = new google.maps.places.PlacesService(document.createElement("div"));
      let request = {
        placeId: id,
        fields: ["opening_hours"],
      };

      service.getDetails(request, (place, status) => {
        if (
          status === google.maps.places.PlacesServiceStatus.OK &&
          place &&
          place.opening_hours
        ) {
          let days = place.opening_hours.periods;
          for (var i = 0; i < days.length; i++) {
            let day = days[i]['open']['day'];
            let container = parent.querySelector('.day' + day);
            container.classList.add('has-hours');
            container.querySelector('.open').textContent = formatTime(days[i]['open']['time']);
            container.querySelector('.close').textContent = formatTime(days[i]['close']['time']);
          }
        }
      });
    };

    let getHoursM = (id, parent) => {

      const service = new google.maps.places.PlacesService(document.createElement("div"));
      let request = {
        placeId: id,
        fields: ["opening_hours",'utc_offset_minutes'],
      };

      service.getDetails(request, (place, status) => {
        if ( status === google.maps.places.PlacesServiceStatus.OK && place && place.opening_hours ) {
          const d = new Date();
          let day = d.getDay()-1;

          const dzone = d.toLocaleString('fr-FR', { timeZone: "Europe/Zurich" });
          const tzone = dzone.split(" ")[1];
          const hzone = tzone.split(":")[0];
          const mzone = tzone.split(":")[1];
          const time = parseInt((hzone+mzone));

          if(place.opening_hours.isOpen()) {
            parent.querySelector('.txt_open').style.display = 'block';
            parent.querySelector('.txt_close').style.display = 'none';
            if(day < 0) {
              day = 6;
            }
            let hours = place.opening_hours.periods[day];
            parent.querySelector('.txt_open .close').textContent = formatTime(hours['close']['time']);
          }
          else {
            let txt;
            parent.querySelector('.txt_open').style.display = 'none';
            parent.querySelector('.txt_close').style.display = 'block';
            const openT = parseInt(place.opening_hours.periods[day]['open']['time']);
            if((place.opening_hours.periods[day]) && (time < openT)) {
              if(document.documentElement.lang == "en-US") {
                txt = "Today";
              } else {
                txt = "Aujourd'hui";
              }
            }
            else {
              day++;
              if(day > 6) {
                day = 0;
              }
              if (!place.opening_hours.periods[day]) {
                if(day+1 > 6) {
                  day = 0;
                } else {
                  day++;
                }

                if (!place.opening_hours.periods[day]) {
                  day++;
                  if(day > 6) {
                    day = 0;
                  }
                }

                txt = formatDay(day);
              }
              else {
                if(document.documentElement.lang == "en-US") {
                  txt = "Tomorrow";
                } else {
                  txt = "Demain";
                }
              }
            }

            let hours = place.opening_hours.periods[day];
            parent.querySelector('.txt_close .hour').textContent = formatTime(hours['open']['time']);
            parent.querySelector('.txt_close .day').textContent = txt;
          }
        }

      });

    }

    function formatTime(strTime) {
      let h = strTime.slice(0, 2);
      let m = strTime.slice(-2);
      return h + 'h' + m;
    }

    function formatDay(day) {
      let dayName;

      if(document.documentElement.lang == "en-US") {
        if(day ==0) {
          dayName = "Monday";
        }
        if(day == 1) {
          dayName = "Tuesday";
        }
        if(day == 2) {
          dayName = "Wednesday";
        }
        if(day == 3) {
          dayName = "Thursday";
        }
        if(day == 4) {
          dayName = "Friday";
        }
        if(day == 5) {
          dayName = "Saturday";
        }
        if(day == 6) {
          dayName = "Sunday";
        }
      } else {
        if(day ==0) {
          dayName = "Lundi";
        }
        if(day == 1) {
          dayName = "Mardi";
        }
        if(day == 2) {
          dayName = "Mercredi";
        }
        if(day == 3) {
          dayName = "Jeudi";
        }
        if(day == 4) {
          dayName = "Vendredi";
        }
        if(day == 5) {
          dayName = "Samedi";
        }
        if(day == 6) {
          dayName = "Dimanche";
        }
      }
      return dayName;
    }

    initFunc();

  };
}
export { Horaire }
